import { useCallback, useContext, useEffect, useRef } from 'react';

import ElementType from '../../../constants/ElementType';
import { MktType } from '../../../constants/MktType';
import { LogFirehoseContext } from '../../../context/devLogFirehose';
import useActions from '../../../hooks/useActions';
import { logImpressionBatch } from '../../../redux/actions/analyticsLog';
import { Impression } from '../../../types/CTR';

interface Props {
  enabled: boolean;
  promoteItems: string[];
  layoutName: string;
}

export default (props: Props) => {
  const { enabled, promoteItems, layoutName } = props;
  const accItems = useRef(new Set<string>());

  const { updateFirehoseLogStateForDebug } = useContext(LogFirehoseContext);

  const logImpressions = useActions(logImpressionBatch);

  useEffect(() => {
    if (enabled) {
      const items = promoteItems.reduce<Impression[]>((acc, item, index) => {
        const accumulated = accItems.current.has(item);

        if (accumulated || /blank/.test(item)) {
          return acc;
        }

        const pitNumber = index + 1;

        accItems.current.add(item);

        return acc.concat({
          elementType: ElementType.PromoteItem,
          id: item,
          layoutName,
          mktType: MktType.Image,
          pitNumber,
        });
      }, []);

      if (items.length > 0) {
        logImpressions({ data: items });
        updateFirehoseLogStateForDebug();
      }
    }
  }, [
    enabled,
    promoteItems,
    logImpressions,
    updateFirehoseLogStateForDebug,
    layoutName,
  ]);

  const clearImpressions = useCallback(() => {
    accItems.current.clear();
  }, []);

  return [accItems, clearImpressions] as [
    typeof accItems,
    typeof clearImpressions
  ];
};
